import Vue from 'vue';
import App from './App.vue';
import './plugins/element.js';
import vuetify from './plugins/vuetify';
import router from './router';
import VueClipboard from 'vue-clipboard2'

import Store from './store/store.js';

import firebase from "./firebaseConfig";
const db = firebase.firestore();
// const analytics = firebase.analytics();
const auth = firebase.auth();

Vue.config.productionTip = false
Vue.use(VueClipboard);

new Vue({
  router,
  vuetify,
  render: h => h(App),
  data: {
    appStore: Store,
    db: db,
    auth: auth,
    // analytics: analytics,
  },
}).$mount('#app')
